import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Modal,
  Paper,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { Info as InfoIcon, Close as CloseIcon, Calculate as CalculateIcon } from '@mui/icons-material';

const InfoWeightedAverage = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Button
        // variant="text"
        startIcon={<InfoIcon />}
        onClick={handleOpen}
        size='small'
        variant='outlined'
        sx={{
          textTransform: 'none',
          color: 'primary.main',
          // '&:hover': {
          //   backgroundColor: 'primary.light',
          //   color: 'white',
          // },
        }}
      >
        Come viene calcolato il grado proposto?
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="weighted-average-modal"
        aria-describedby="weighted-average-description"
        disableEscapeKeyDown
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '600px' },
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <Paper sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h5" component="h2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CalculateIcon color="primary" />
                Calcolo del Grado Proposto
              </Typography>
              <IconButton onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider sx={{ mb: 3 }} />

            <Typography variant="body1" paragraph>
              Il grado proposto viene calcolato utilizzando una <strong>media ponderata</strong> basata sulla 
              frequenza con cui ogni grado viene proposto dagli utenti.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
              Come funziona:
            </Typography>

            <List>
              <ListItem>
                <ListItemIcon>
                  <Typography variant="h6" color="primary">1</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Conteggio Frequenze"
                  secondary="Si conta quante volte ogni grado viene proposto (es. 6a proposto 3 volte, 6b proposto 2 volte)"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Typography variant="h6" color="primary">2</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Peso per Frequenza"
                  secondary="Il peso di ogni grado è determinato dal numero di volte che viene proposto"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Typography variant="h6" color="primary">3</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Conversione Grado"
                  secondary="Ogni grado viene convertito in un valore numerico (es. 6a = 6.4, 6a+ = 6.6, 6b = 6.8)"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Typography variant="h6" color="primary">4</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Calcolo Media Ponderata"
                  secondary="Media = (Σ grado × frequenza) / Σ frequenza"
                />
              </ListItem>

              <ListItem>
                <ListItemIcon>
                  <Typography variant="h6" color="primary">5</Typography>
                </ListItemIcon>
                <ListItemText
                  primary="Conversione Finale"
                  secondary="Il risultato numerico viene riconvertito nel formato grado più vicino"
                />
              </ListItem>
            </List>

            <Box sx={{ mt: 3, p: 2, backgroundColor: 'grey.50', borderRadius: 1 }}>
              <Typography variant="h6" gutterBottom color="primary">
                Esempio Pratico:
              </Typography>
              <Typography variant="body2" paragraph>
                Se abbiamo le seguenti proposte:
              </Typography>
              <Typography variant="body2" component="div">
                • <strong>6a</strong> proposto 3 volte (peso 3) → 6.4 × 3 = 19.2
              </Typography>
              <Typography variant="body2" component="div">
                • <strong>6b</strong> proposto 2 volte (peso 2) → 6.8 × 2 = 13.6
              </Typography>
              <Typography variant="body2" component="div">
                • <strong>6a+</strong> proposto 1 volta (peso 1) → 6.6 × 1 = 6.6
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <strong>Media = (19.2 + 13.6 + 6.6) / (3 + 2 + 1) = 39.4 / 6 = 6.57</strong>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Il grado finale sarà <strong>6a+</strong> (il più vicino a 6.57)
              </Typography>
            </Box>

            

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" onClick={handleClose}>
                Ho capito
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>
    </Box>
  );
};

export default InfoWeightedAverage;
